define(function(require) {
	// general
	const $ = require('jquery');
	const CommonInspectionCode = require('civicsViews/inspection_request/common/common');
	const CN = require('civicsUtils/constants');
	const Utils = require('civicsUtils/general_utilities');
	const ViewManager = require('civicsUtils/view_manager');
	const constants = require('civicsUtils/constants');
	// models
	const CdrLogModel = require('civicsModels/cdr_log_model');
	const InspectionModel = require('civicsModels/inspection_model');
	const RequestInspectionModel = require('civicsModels/request_inspection_model');
	// collections
	const ServiceProvidersCollection = require('civicsCollections/service_providers_collection');
	const TimePreferencesCollection = require('civicsCollections/code_definition_collection');
	// templates
	const tpl = require('civicsViews/inspection_request/templates/t_itv_inspection_request.hbs');
	// constants
	const INSPECTION_STATE = CN.INSPECTION_STATE();
	//utilities
	const AvailableFeatures = require('civicsUtils/available_features');

	return Marionette.ItemView.extend({
		FILTERCODEMODELID: 'InspectionRequest',
		initialize: function(options) {
			// if(__DEV__) console.log('inspection -- initialize');
			this.options = options;
			this.config = options.config;
			this.modalRegion = options.modalRegion;
			this.model = options.model;
			this.isPopulateAssignProvider = options.isPopulateAssignProvider;
			this.parentView = options.parentView;
			this.config.INSPECTION_STATE = INSPECTION_STATE;
			this.config.isProvider = App.user.isServiceProvider;
			//Inspection Request Date config
			this.config.requireRequestDate = this.config.globalConfig.usesInspectionRequestDate == 'Required';
			this.config.displayOnlyRequestDate = this.config.globalConfig.usesInspectionRequestDate == 'DisplayOnly';

			if(!this.config.globalConfig){
				this.config.globalConfig = ViewManager.globalConfig().toJSON();
			}
			this.addToStore(this.config.portletId, this.FILTERCODEMODELID, this.model);

			if(AvailableFeatures.FetchServiceProviderOnSingleRecord()) {
				if(this.config.globalConfig.useServiceProviders){
					ViewManager.loading(true);
					inspectionServiceProviderModel = new InspectionModel();
					inspectionServiceProviderModel.set('id', this.model.get('id'));
					inspectionServiceProviderModel.urlRoot = inspectionServiceProviderModel.urlRoot.format(this.config.fromServer.instrumentType);

					inspectionServiceProviderModel.fetch()
					.done(function(response, status, xhrResponse) {
						if(response.data && response.data.serviceProviders){
						this.serviceProvidersCollection = new ServiceProvidersCollection(response.data.serviceProviders);
						}else{
						this.serviceProvidersCollection = new ServiceProvidersCollection();
						}
						
						// request is from My Task. The assignedToProvider is not populated so we will pull that from inspection fetch
						if(this.isPopulateAssignProvider && response.data.assignedToProvider){
							this.model.set('assignedToProvider', new Backbone.Model(response.data.assignedToProvider));
							this.providerValue = this.model.get('assignedToProvider.id');
						}
						this.render();
						ViewManager.loading(false);
					}.bind(this))
					.fail((response, status, xhrResponse)=>{
						ViewManager.loading(false);
						ViewManager.errorToWindow(response, this, {"isCustomValidation": true});
					});
				}
			}
			else{
				if( this.model.get('serviceProviders') && this.model.get('serviceProviders').length > 0 ){
					this.serviceProvidersCollection = new ServiceProvidersCollection(this.model.get('serviceProviders').models);
				}
				else {
					this.serviceProvidersCollection = new ServiceProvidersCollection();
				}
			}

			// Determine if this is an initial inspection request or a reschedule request
			this.isRescheduleRequest = false;
 			this.requestDate = this.config.captureRequestDateToCallDate ?
				this.model.get('callDateTime') :
				this.model.get('scheduledDateTime');
			if (Utils.dateExists(this.requestDate)) {
				this.isRescheduleRequest = true;
			} else {
				this.requestDate = null;
			}

			this.providerValue = this.model.get('assignedToProvider.id');
			this.timeValue = this.model.get('timePreference');

		},
		onDomRefresh: function(){
			this.ui.specialInstructions.maxlength({
				liveRegion: $('<p class="helper-msg character-counter" aria-live="polite"></p>')
			});
		},
		onRender:function(){
			// if(__DEV__) console.log('inspection -- onRender');
			this.$el.rhythmCivicsTooltipInit();
      this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
			this.inputChanged();

			this.ui.locationDetails.maxlength();
			this.setupFilterCodes(this.config.fromServer.instrumentType);
			// hide all error messages
			ViewManager.resetErrorMessages(this);
		},
		onShow:function(){
	 		this.inputChanged();


		},
		className: 'inspection-request-modal',
		template: tpl,
		events: {
			'click @ui.btnCancel': 'cancelClicked',
			'click @ui.btnClose': 'closeClicked',
			'click @ui.btnSubmitRequest': 'submitRequestClicked',
			'change @ui.requestDate': 'inputChanged',
			'input @ui.requestDate': 'inputChanged',
			'keyup @ui.requestDate': 'inputChanged',
			'paste @ui.requestDate': 'inputChanged',
			'blur @ui.requestDate': 'inputChanged',
			'blur @ui.locationDetails': 'inputChanged',
			'droppyChange @ui.providers': 'droppyProviderChanged',
			'droppyChange @ui.timePreferences': 'droppyTimeChanged',
			},
		ui:{
			btnCancel:'.btn-cancel',
			btnClose:'.bbm-btn-close',
			btnOk:'.btn-ok',
			btnSubmitRequest:'.btn-submit-request',
			dayPhone: '.day-phone',
			mobilePhone: '.mobile-phone',
			emailAddress: '.email-address',
			locationDetails: '#location-details',
			locationDetailsConfirmation: '.location-details-confirmation',
			providers: '.assign-container .droppy',
			providersConfirmation: '.providers-confirmation',
			requestDate: '#requestDate',
			requestDatePicker: '#request-date',
			requestedDateConfirmation: '.requested-date-confirmation',
			timePreferences: '.request-time-container .droppy',
			timePreferencesConfirmation: '.time-preferences-confirmation',
			specialInstructions: '#special-instructions'
		},
		inputChanged:function(){
			// if(__DEV__) console.log('inspection -- inputChanged');
			if (this.hasServiceProviders()) {
				var providers = this.serviceProvidersCollection.where({id:Number(this.providerValue)});
				if(__DEV__) console.log('inspection -- providers: ', providers);
				if (providers.length == 1) {
					//ViewManager.resetErrorMessages(this);
					this.ui.dayPhone.html(providers[0].get('dayPhone'));
					this.ui.mobilePhone.html(providers[0].get('mobileNumber'));
					this.ui.emailAddress.html(providers[0].get('eMailAddress'));
					this.ui.providersConfirmation.html(providers[0].get('identity.firstName') + ' ' + providers[0].get('identity.lastName'));
				}
			}
			var timePreferences = this.config.timePreferencesCollection.where({code: this.timeValue});
			if (timePreferences.length == 1) {
				this.ui.timePreferencesConfirmation.html(timePreferences[0].get('description'));
			}
			var data = ViewManager.fromWindow(this);
			if(this.config.displayOnlyRequestDate)
				data.requestDate = this.requestDate;
			this.ui.requestedDateConfirmation.html(Handlebars.helpers['global:formatDate'](data.requestDate));
			this.ui.locationDetailsConfirmation.html(Handlebars.helpers['global:sanitize'](this.ui.locationDetails.val()));
		},
		droppyProviderChanged: function(data){
			this.providerValue = data ? data.result.data : this.providerValue;
			this.inputChanged();
		},
		droppyTimeChanged: function(data){
			this.timeValue = data ? data.result.data : this.timeValue;
			this.inputChanged();
		},
		cancelClicked:function(){
			if(__DEV__) console.log('inspection -- cancelClicked');

			this.triggerMethod('cancelInspectionRequest:clicked');

			if(this.modalRegion) {
				this.modalRegion.hideModal();
			}
			else {
				this.destroy();
			}
		},
		closeClicked:function(){
			if(__DEV__) console.log('inspection -- closeClicked');

			this.triggerMethod('closeInspectionRequest:clicked');

			if(this.modalRegion) {
				this.modalRegion.hideModal();
			}
			else {
				this.destroy();
			}
		},
		enableButtons: function(enable){
			this.ui.btnCancel.prop('disabled', !enable);
			this.ui.btnClose.prop('disabled', !enable);
			this.ui.btnOk.prop('disabled', !enable);
			this.ui.btnSubmitRequest.prop('disabled', !enable);
		},
		submitRequestClicked:function(){
			if(__DEV__) console.log('inspection -- submitRequestClicked');
			this.enableButtons(false);
			var self = this;
			// hide all error messages
			ViewManager.resetErrorMessages(this);
			var data = ViewManager.fromWindow(this);

			//validates the fields in the modal
			var hasFieldError = this.fieldValidation();
			if(hasFieldError){
				return;
			}

			var requestDate = Utils.dateString(data.requestDate, null);//zFixed
			// if(requestDate != ''){
			// 	data.requestDate = requestDate.substring(0,requestDate.length-1);//remove ending 'Z' removeOffset
			// }
			// else {
				if(AvailableFeatures.SpecialInstructions()){
					var inspectionModel = new RequestInspectionModel();
					inspectionModel.set({'contactPerson':data.contactPerson});
					inspectionModel.set({'contactInfo':data.contactInfo});
					inspectionModel.set({'specialInstructions':data.specialInstructions});
				} else {
					var inspectionModel = new InspectionModel();
				}
				inspectionModel.set({id: this.model.get('id')});
				if(this.showPartialInspection())
					inspectionModel.set({'isPartial':data.partialInspection});
				if (this.config.captureRequestDateToCallDate) {
					inspectionModel.set({'callDateTime':requestDate});
				} else {
					inspectionModel.set({'scheduledDateTime':requestDate});
				};
				inspectionModel.set({'timePreference':this.timeValue});
				if (this.hasServiceProviders()) {
					inspectionModel.set({'assignedToProvider':{id:Number(this.providerValue)}});
				}
				inspectionModel.set({'location':data.locationDetails});

				inspectionModel.formatUrlRoot(this.config.fromServer.instrumentType);

				inspectionModel.save(null, {})
				.done(function(response, status, xhrResponse) {
					ViewManager.broadcast(self,'saved');
					ViewManager.loading(false);
					if(__DEV__) console.log('inspection -- done function after save model');

					self.triggerMethod('submitInspectionRequest:clicked', response.data);

					if (self.parentView){
						self.parentView.inspectionRequested(response.data);
					} else {
						self.triggerMethod('inspectionRequested');
					}

					if(self.modalRegion) {
						self.modalRegion.hideModal();
					}
					else {
						self.destroy();
					}
				})
				.fail((response, status, xhrResponse) => {
					ViewManager.errorToWindow(response, this, {"isCustomValidation": true});
					ViewManager.loading(false);
					this.enableButtons(true);
				});


		},
		fieldValidation: function(){
			var self = this;
			var hasError = false;
			var data = ViewManager.fromWindow(this);
			var error = {};
			error.validationError = {};

			ViewManager.loading(true);
			var requestDate = Utils.dateTimeString(data.requestDate, null);//zFixed

			//request date is required if there are no service providers, and request date is not hidden or displayonly
			if(requestDate == '' || requestDate == CN.DATE_TIME_MIN_VAL){
				if ( (!this.hasServiceProviders() || this.config.requireRequestDate )&& !this.config.displayOnlyRequestDate && this.showRequestDate() ) {
					//request date is required if there are no service providers
					error.validationError.requestDate = i18n.t('CIVICS.COMMON.REQUEST_DATE_ERROR');
					hasError = true;
					this.enableButtons(true);
					data.requestDate = CN.DATE_TIME_MIN_VAL;
				}


			}

			if (this.hasServiceProviders()) {
				// Assigned To Provider is required
				if (this.providerValue == null || this.providerValue <= 1) {
					error.validationError.providers = i18n.t('CIVICS.COMMON.ASSIGN_TO_REQ');
					hasError = true;
					this.enableButtons(true);
				}
			}
			if(hasError){
				ViewManager.errorToWindow(error, this);
				this.scrollToError();
				ViewManager.loading(false);
			}
			return hasError;

		},
		scrollToError: function(){
			var scrollTop;
			var errorMessage = this.$el.find('.error-message:visible:first').closest('.helper-msg-container');
			var containerModal = $('.bbm-modal');
			var scrollTop = $(containerModal.find(errorMessage).parent()).offset().top - containerModal.offset().top + containerModal.scrollTop();

			if (scrollTop) {
				containerModal.animate({
					scrollTop: scrollTop
				}, 400);
			}
		},
		hasServiceProviders: function(){
			if(this.serviceProvidersCollection)
				return this.serviceProvidersCollection.length > 0;

			return false;
		},
		showRequestDate: function(){
			return this.config.globalConfig.usesInspectionRequestDate != 'Hide';
		},
		showPartialInspection: function(){
			let isShowPartial = true;
			if(this.config.isCustomer){
				if(this.config.useBackOfficeInspectionConfig)
					isShowPartial = this.config.viewOptions.allowPartial;
				else
					isShowPartial = this.config.allowPartialInspectionRequest;
			}
			return isShowPartial;
		},
		templateHelpers: function() {
			var self = this;
			var customAttr = '';
			if(this.requestDate!=null){
				customAttr = 'data-defaultDate="'+Utils.removeTimeZone(this.requestDate)+'"';
			}
			var helpers = {
				showPartial: this.showPartialInspection(),
				showSpecialInstructionsFields: AvailableFeatures.SpecialInstructions(),
				customAttr:customAttr,
				requestDate: Handlebars.helpers['global:formatDate'](this.requestDate),
				timePreferencesCollection: this.config.timePreferencesCollection.toJSON(),
				maxInspContactInfoLength: AvailableFeatures.MaxInspContactInfoLength(),
				showMobileNumber: AvailableFeatures.DisplayMobileNumber(),
				phoneLabel: AvailableFeatures.DisplayMobileNumber() ? i18n.t('CIVICS.INSPECTION_REQUEST.ALTERNATE_PHONE') : i18n.t('CIVICS.INSPECTION_REQUEST.PHONE'),
				showRequestDate: this.showRequestDate(),
				requireRequestDate: (this.config.requireRequestDate || !this.hasServiceProviders()) && !this.config.displayOnlyRequestDate,
				config: this.config,
				title: function() {
					return self.isRescheduleRequest ?
						i18n.t('CIVICS.INSPECTION_REQUEST.RESCHEDULE_REQUEST') :
						i18n.t('CIVICS.INSPECTION_REQUEST.INSPECTION_REQUEST');
				},
				hasServiceProviders: function () {
					return self.hasServiceProviders();
				},
				serviceProvidersCollection: function() {
					if (self.hasServiceProviders()){
						var cmp = function(a, b) {
							if (a > b) return +1;
							if (a < b) return -1;
							return 0;
						};
						var sp = self.serviceProvidersCollection.toJSON().sort(function(a,b){
							if(a.identity && b.identity){
								return cmp(a.identity.lastName.toLowerCase(), b.identity.lastName.toLowerCase())
								|| cmp(a.identity.firstName.toLowerCase(),b.identity.firstName.toLowerCase());
							}
							return 0;
						});

						return sp;
					}
					else
						return [].toJSON();
				},
				concatDroppyOption: function(firstName,lastName) {
					if(firstName){
						return firstName+' '+lastName;
					}else{
						return lastName;
					}
				}
			};

			// Add the common helpers
			_.extend(helpers, CommonInspectionCode.commonHelpers(this));
			return helpers;
		}
	});
});
